var map = {
	"./01-San-Miguel-Corporation.jpg": "./src/img/works/01-San-Miguel-Corporation.jpg",
	"./02-Kia-Philippines.jpg": "./src/img/works/02-Kia-Philippines.jpg",
	"./03-Red-Lab-Gallery.jpg": "./src/img/works/03-Red-Lab-Gallery.jpg",
	"./04-CBC-iLink.jpg": "./src/img/works/04-CBC-iLink.jpg",
	"./05-Alfred.jpg": "./src/img/works/05-Alfred.jpg",
	"./alfred.png": "./src/img/works/alfred.png",
	"./edm.png": "./src/img/works/edm.png",
	"./hive.png": "./src/img/works/hive.png",
	"./hris.png": "./src/img/works/hris.png",
	"./ilink.png": "./src/img/works/ilink.png",
	"./smm.png": "./src/img/works/smm.png",
	"./web.png": "./src/img/works/web.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/works sync \\.(png%7Cjpe?g%7Csvg)$";